"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, FlexCenter, NumberDisplay, SpaceBetween, TextBody, Tooltip } from "@opensea/ui-kit";
import { Info } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { useTranslations } from "use-intl";
export function SwapImpact(t0) {
  const $ = _c(28);
  const {
    className,
    percent,
    usd
  } = t0;
  const t = useTranslations("wallet.SwapImpact");
  let t1;
  if ($[0] !== className) {
    t1 = classNames("w-full items-center gap-1 p-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("swapImpact");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <TextBody>{t2}</TextBody>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("swapImpactTooltip");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TextBody color="text-secondary"><Info size={16} /></TextBody>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <Tooltip content={t4}>{t5}</Tooltip>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <FlexCenter className="gap-1.5">{t3}{t6}</FlexCenter>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== usd) {
    t8 = <TextBody className="font-mono" color="text-secondary">(<NumberDisplay display="usd" value={usd} />)</TextBody>;
    $[14] = usd;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      maximumFractionDigits: 2
    };
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== percent) {
    t10 = bn(percent).div(100);
    $[17] = percent;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <TextBody asChild={true} color="error-1"><NumberDisplay custom={t9} display="percent" value={t10} /></TextBody>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t8) {
    t12 = <FlexCenter className="gap-1.5">{t8}{t11}</FlexCenter>;
    $[21] = t11;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t1 || $[25] !== t12 || $[26] !== t7) {
    t13 = <SpaceBetween className={t1}>{t7}{t12}</SpaceBetween>;
    $[24] = t1;
    $[25] = t12;
    $[26] = t7;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}